import { Link, useLocation } from '@tanstack/react-router';
import { AddressNotFound, buttonClasses, FailureNotice, Page } from '@evogard/ui';

/** A anatomia é `FailureNotice`, de `@evogard/ui`; aqui só a frase da interna. */
export function Failure({ error }: { error: Error }) {
  return (
    <FailureNotice title="A plataforma não respondeu" error={error}>
      Não foi possível falar com o servidor. Costuma ser conexão ou uma reinicialização em
      andamento — seus dados não foram alterados.
    </FailureNotice>
  );
}

/**
 * Fora do layout — sem menu, porque não há sessão por perto —, mas com a mesma
 * anatomia de `NotFoundScreen` (`AddressNotFound`). A saída é o roteador, e não
 * uma recarga da aplicação inteira.
 */
export function NotFound() {
  const path = useLocation({ select: (l) => l.pathname });
  return (
    <Page className="p-6 md:p-10">
      <AddressNotFound
        path={path}
        renderLink={({ to, className, children }) => (
          <Link to={to} className={className}>
            {children}
          </Link>
        )}
        actions={
          <Link to="/" className={buttonClasses()}>
            Ir para o início
          </Link>
        }
      />
    </Page>
  );
}
